export interface AppConfig {
  serverIP: string;
  serverPort: string;
  syncBaseURL: string;
  syncSocketURL: string;
}

let cache: AppConfig | null = null;

/**
 * Loads /config.json served by the Control UI's Express server.
 * The server populates it from HOST_IP/SYNC_SERVER_PORT env vars.
 */
export async function loadConfig(): Promise<AppConfig> {
  if (cache) return cache;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Failed to load /config.json (${res.status})`);
  const data = (await res.json()) as { serverIP: string; serverPort: string };
  const base = `https://${data.serverIP}:${data.serverPort}`;
  cache = {
    ...data,
    syncBaseURL: base,
    syncSocketURL: base,
  };
  return cache;
}
